import { render, staticRenderFns } from "./FaviconBox.vue?vue&type=template&id=747af222&"
import script from "./FaviconBox.vue?vue&type=script&lang=js&"
export * from "./FaviconBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports